import styled from 'styled-components';

export const ModuleContainer = styled.div`
  width: 100%;
  height: 100vh;
`;
